import { msalInstance, loginRequest } from "./browserAuthProvider";
import { nativeLogin, nativeLogout, nativeGetToken } from "./nativeAuth";
import { getUserProfileAsync, getUserPhotoAsync, StaffProfile } from "./authConfig";
import { authProvider } from "./provider";
import AUTH_CONFIG from "../../configs/authConfig";

/**
 * Acquire an access token for API requests (BFF).
 * Uses the configured scope from environment variables.
 * Falls back to User.Read if no scope is configured.
 */
export const acquireAccessToken = async (): Promise<string> => {
	try {
		const scopes = AUTH_CONFIG.scope ? [AUTH_CONFIG.scope] : ["User.Read"];
		const result = await authProvider.getToken(scopes);
		if (!result) {
			throw new Error("No authenticated account is available");
		}
		return result.accessToken;
	} catch (error) {
		console.error("Failed to acquire access token:", error);
		throw error;
	}
};

// Export type for consumers
export type { IAuthProvider } from "./types";

// Re-export auth provider
export { authProvider };

// Export the universal auth gate
export { AuthGate } from "./AuthGate";

// Re-export auth utilities for components that need to check auth mode
export { isNativeApp, isNativeAppSsoEnabled } from "./nativeAuth";

// Re-export native auth functions (for backward compatibility)
export { nativeLogin, nativeLogout, nativeGetToken };

// Re-export Graph API utilities
export { getUserProfileAsync, getUserPhotoAsync, type StaffProfile };

// Re-export MSAL config for MsalProvider (if needed)
export { msalInstance, loginRequest };
